// library
import classNames from "classnames";

// material ui components
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

interface Props {
  onNext: () => void;
  onPrev: () => void;
  steps: number;
  activeStep: number;
}
const OnBoardingStepper = ({ onNext, onPrev, steps, activeStep }: Props) => {
  const handleNext = () => {
    onNext();
  };

  const handleBack = () => {
    onPrev();
  };

  const array = new Array(steps).fill("");

  return (
    <Stack direction={"column"} justifyContent="space-between">
      <Box className={styles.pointer_wrapper}>
        {array?.map((_, index) => (
          <Box
            className={classNames(
              index + 1 === activeStep
                ? styles["pointer_active"]
                : styles["pointer"]
            )}
            key={index}
          />
        ))}
      </Box>

      <Box className={styles.nav_wrapper}>
        <Button className={styles.button} size="small" onClick={handleBack}>
          <KeyboardArrowRight />
        </Button>
        <Button className={styles.button} size="small" onClick={handleNext}>
          <KeyboardArrowLeft />
        </Button>
      </Box>
    </Stack>
  );
};

export default OnBoardingStepper;
